<template>
	<div class="org-manage">
		<pvcam-wc-node-manager
			v-if="org"
			:vehicle="false"
			:user="false"
			:org="org"
			:reenter="reenter"
			@autocomplete="autocomplete"
		></pvcam-wc-node-manager>
	</div>
</template>

<script>
	import { Logger } from "aws-amplify";
	const logger = new Logger("OrgManage");
	import avro from "avsc";
	const type = avro.Type.forSchema({
		type: "array",
		items: {
			type: "record",
			name: "vehicle",
			namespace: "com.test.avro",
			fields: [
				{
					name: "id",
					type: "string"
				},
				{
					name: "nodeId",
					type: "string"
				},
				{
					name: "v_name",
					type: "string"
				}
			]
		}
	});
	export default {
		data: () => ({
			dropped: 0,
			reenter: false,
			vehicles: []
		}),
		computed: {
			org() {
				if (this.$route.params.name) {
					return this.$route.params.name;
				}
				return null;
			}
		},
		mounted() {
			// document.addEventListener("drop", this.handleDrop);
			// this.$el.addEventListener("dragleave", this.handleDrop);
			this.$el.addEventListener("dragenter", this.handleReEnter);
			// this.fetchAvro();
		},
		beforeDestroy() {
			// document.removeEventListener("drop", this.handleDrop);
			// this.$el.removeEventListener("dragleave", this.handleDrop);
			this.$el.removeEventListener("dragenter", this.handleReEnter);
		},
		methods: {
			autocomplete() {},
			// handleDrop() {
				// this.dropped++;
			// },
			handleReEnter() {
				this.reenter++;
			},
			decode(buf) {
				logger.info(new Date().getTime(), "start", buf);
				const res = type.fromBuffer(buf);
				logger.info(new Date().getTime(), res);
			},
			fetchAvro() {
				fetch("https://localhost/vehicles_array.avro")
					.then(response => response.blob())
					.then(res => {
						const reader = avro
							.createBlobDecoder(res)
							.on("metadata", type => {
								logger.info("type", type);
								/* `type` is the writer's type. */
							})
							.on("data", val => {
								logger.info("val", val);
								this.vehicles.push(val);
								/* Do something with the decoded value. */
							});
						logger.info(reader);
					});
			}
		}
	};
</script>